/**
 * Renders a single `<script type="application/ld+json">` block for PL PDP pages.
 *
 * SSR emits the PL-provided `meta.seoData.jsonLd` string verbatim — PL owns JSON-LD
 * generation (variant selection, localization, currency). No SSR-side building.
 */
import { getNonce } from '@src/utils/nonce.utils'

export interface ProductPageSchemaProps {
  jsonLd: string
  /** Provenance marker rendered as `data-seo-source` on the ld+json script tag. */
  seoSource?: 'pl-jsonld'
}

export const ProductPageSchema = ({ jsonLd, seoSource }: ProductPageSchemaProps): JSX.Element | null => {
  if (!jsonLd) return null

  return (
    <script
      id="pl-pdp-jsonld"
      type="application/ld+json"
      nonce={getNonce() ?? undefined}
      data-seo-source={seoSource}
      data-seo-rendered="server"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: jsonLd.replace(/</g, '\\u003C') }}
    />
  )
}
